import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { Fragment } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { assingDocumentsForRequiredActionInSoftExpert } from '../../../../api/ActionRequired';
import { linkingDocumentsToRequestInSoftExpert, uploadFormDocuments } from '../../../../api/RequestService';
import UploadFile from '../../../../components/UploadFile/UploadFile';
import { HideGlobalLoading, ShowGlobalLoading } from '../../../../redux/actions/UiActions';
import { SmallHeightDivider } from '../../../../theme/Styles';
import COLORS from '../../../../theme/Colors';
import FONTS_FAMILY from '../../../../theme/FontsFamily';
import { FileFormSchema } from './ActionsRequiredConstants';

function ActionsRequired(props) {
    const matchesWidth = useMediaQuery('(min-width:768px)');
    const history = useHistory();
    let { requestID } = useParams();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const requestData = queryClient.getQueryData(['serviceRequestedDetail', requestID]);
    const statusId = requestData?.request?.status_id;

    

    const actionRequiredFileMutation = useMutation(assingDocumentsForRequiredActionInSoftExpert, {
        onMutate: (req) => {
            dispatch(ShowGlobalLoading('Cargando'));
        }
    });

    const fileFormik = useFormik({
        initialValues: {
            file: null
        },
        validationSchema: FileFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            handleSubmitFile(values);
        }
    });

    const handleSubmitFile = async (values) => {
        let uploadedFilesRoutes = [];
        const formFileData = new FormData();
        for (let i = 0; i < values.file.files.length; i++) {
            formFileData.append('file[]', values.file.files[i], values.file.files[i].name);
        }
        const uploadFilesConfig = {
            onUploadProgress: (progressEvent) => {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                dispatch(ShowGlobalLoading(`Subiendo documentos ${percentCompleted}%`));
            }
        };
        let responseFilesUpload = await uploadFormDocuments(formFileData, uploadFilesConfig);
        if (responseFilesUpload.success) {
            fileFormik.resetForm();
            uploadedFilesRoutes = [
                ...responseFilesUpload.files.map((item, index) => {
                    return {
                        ...item,
                        label: `DOC Accion requerida - ${item.name}`
                    };
                })
            ];
            dispatch(ShowGlobalLoading('Procesando'));
            // Los archivos se envían a SoftExpert de forma asíncrona: el backend encola
            // un job por archivo y, al terminar todos, ejecuta la actividad del workflow.
            await linkingDocumentsToRequestInSoftExpert(
                requestData.request.code,
                uploadedFilesRoutes.map((file) => ({ ...file })),
                { activity_id: props?.data?.activity_id, advance_activity: true }
            );
            const assignmentData = {
                documents: uploadedFilesRoutes,
                record_id: requestData.request.code,
                status: true,
                required_action_id: props?.data?.id
            };
            actionRequiredFileMutation.mutate(assignmentData, {
                onSuccess: () => {
                    enqueueSnackbar('Documento requerido enviada satisfactoriamente', { variant: 'success' });
                    queryClient.invalidateQueries(['serviceRequestedDetail', requestID]);
                    setTimeout(() => {
                        history.push(`/app/serviceRequestedDetails/${requestID}#documents`);
                        props?.finishActionRequired();
                        dispatch(HideGlobalLoading());
                    }, 500);
                },
                onError: () => {
                    dispatch(HideGlobalLoading());
                    enqueueSnackbar('Ha ocurrido un error, contacte a soporte', { variant: 'error' });
                },
                onSettled: () => {}
            });
        } else {
            dispatch(HideGlobalLoading());
            enqueueSnackbar('Ha ocurrido un error, contacte a soporte', { variant: 'error' });
        }
    };

    if (statusId === 10) {
        return (
            <div style={{
                background: '#ffffff',
                borderRadius: '14px',
                border: '1px solid #e2e8f0',
                padding: '40px 24px',
                boxShadow: 'none',
                textAlign: 'center',
            }}>
                <span style={{ fontSize: '48px', display: 'block', marginBottom: '12px', opacity: 0.5 }}>🚫</span>
                <p style={{
                    margin: 0,
                    fontSize: '16px',
                    fontWeight: 600,
                    color: '#64748b',
                    fontFamily: FONTS_FAMILY.bold.body,
                }}>
                    Su solicitud no está abierta
                </p>
                <p style={{
                    margin: '4px 0 0',
                    fontSize: '13px',
                    color: '#94a3b8',
                    fontFamily: FONTS_FAMILY.regular.body,
                }}>
                    Ya no es posible responder acciones requeridas.
                </p>
            </div>
        );
    }

    return (
        <div style={{
            background: '#ffffff',
            borderRadius: '14px',
            border: '1px solid #e2e8f0',
            boxShadow: 'none',
            overflow: 'hidden',
        }}>
            {/* Header */}
            <div style={{
                padding: '18px 24px',
                borderBottom: '1px solid #f1f5f9',
                background: '#fef3c7',
            }}>
                <h3 style={{
                    margin: 0,
                    fontSize: '17px',
                    fontWeight: 700,
                    color: '#92400e',
                    fontFamily: FONTS_FAMILY.bold.body,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                }}>
                    <span style={{ fontSize: '20px' }}>📄</span>
                    Documento requerido
                </h3>
                <p style={{
                    margin: '6px 0 0',
                    fontSize: '13px',
                    color: '#a16207',
                    fontFamily: FONTS_FAMILY.regular.body,
                }}>
                    Suba los documentos solicitados para continuar con su trámite.
                </p>
            </div>

            {/* Upload Area */}
            <div style={{ padding: '24px' }}>
                <UploadFile
                    id="file"
                    title="Documento"
                    onChange={fileFormik.handleChange}
                    onBlur={fileFormik.handleBlur}
                    error={fileFormik.touched.file && Boolean(fileFormik.errors.file)}
                    helperText={fileFormik.touched.file && fileFormik.errors.file}
                    required
                    multipleDocuments
                    value={fileFormik.values.file}
                />
                <SmallHeightDivider />
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                        onClick={fileFormik.handleSubmit}
                        style={{
                            padding: '10px 32px',
                            borderRadius: '8px',
                            border: 'none',
                            background: COLORS.secondary,
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: 600,
                            fontFamily: FONTS_FAMILY.bold.body,
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = COLORS.primary}
                        onMouseLeave={(e) => e.currentTarget.style.background = COLORS.secondary}
                    >
                        ENVIAR
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ActionsRequired;
